import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  SearchableSelectContainer,
  SearchableSelectInput,
  SearchableSelectDropdown,
  SearchableSelectOption,
} from './styles';

export interface SearchableSelectProps {
  options: string[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const SearchableSelect: React.FC<SearchableSelectProps> = ({
  options,
  value,
  onChange,
  placeholder = 'Search...',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const containerRef = useRef<HTMLDivElement>(null);

  const filteredOptions = useMemo(
    () => options.filter(opt => opt.toLowerCase().includes(searchTerm.toLowerCase())),
    [options, searchTerm]
  );

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <SearchableSelectContainer ref={containerRef}>
      <SearchableSelectInput
        type="text"
        placeholder={placeholder}
        value={isOpen ? searchTerm : value === 'all' ? 'All' : value}
        onChange={(e) => setSearchTerm(e.target.value)}
        onFocus={() => setIsOpen(true)}
      />
      {isOpen && (
        <SearchableSelectDropdown>
          {filteredOptions.length === 0 ? (
            <SearchableSelectOption $selected={false} style={{ color: '#9ca3af' }}>
              No results
            </SearchableSelectOption>
          ) : (
            filteredOptions.map((opt) => (
              <SearchableSelectOption
                key={opt}
                $selected={value === opt}
                onClick={() => {
                  onChange(opt);
                  setIsOpen(false);
                  setSearchTerm('');
                }}
              >
                {opt}
              </SearchableSelectOption>
            ))
          )}
        </SearchableSelectDropdown>
      )}
    </SearchableSelectContainer>
  );
};
